import { fetchPageDataFactory } from './v4BaseAction';
/**
 * These actions are required only for offerzone
 */
export var TAB_DATA_ACTIONS;
(function (TAB_DATA_ACTIONS) {
    TAB_DATA_ACTIONS["REQUEST"] = "TAB_DATA_V4_REQUEST";
    TAB_DATA_ACTIONS["SUCCESS"] = "TAB_DATA_V4_SUCCESS";
    TAB_DATA_ACTIONS["ERROR"] = "TAB_DATA_V4_ERROR";
    TAB_DATA_ACTIONS["CLEAR"] = "TAB_DATA__V4_CLEAR";
})(TAB_DATA_ACTIONS || (TAB_DATA_ACTIONS = {}));
export const fetchTabPageData = fetchPageDataFactory(TAB_DATA_ACTIONS.REQUEST, TAB_DATA_ACTIONS.SUCCESS, TAB_DATA_ACTIONS.ERROR);
export function clearTabPageData() {
    return {
        type: TAB_DATA_ACTIONS.CLEAR
    };
}
